import React from 'react';
import TermsAcceptanceModal from './TermsAcceptanceModal';
import PrivacyPolicyContent, { PRIVACY_LAST_UPDATED_LABEL } from './privacyPolicyContent';

interface PrivacyAcceptanceModalProps {
  onAccept: () => void;
  onClose?: () => void;
  loading?: boolean;
  error?: string | null;
  title?: string;
  acceptLabel?: string;
}

/**
 * Thin wrapper around TermsAcceptanceModal's shell (scroll-to-bottom
 * gating, layout, accept/cancel buttons) presenting the Privacy Policy
 * instead of the Terms and Conditions -- kept as a separate component
 * (rather than always passing `content` explicitly at every call site) so
 * callers read the same way RegisterPage/PrivateRoute already read for terms.
 */
export default function PrivacyAcceptanceModal({
  onAccept,
  onClose,
  loading = false,
  error = null,
  title = 'Política de Privacidad',
  acceptLabel = 'Aceptar y continuar',
}: PrivacyAcceptanceModalProps) {
  return (
    <TermsAcceptanceModal
      onAccept={onAccept}
      onClose={onClose}
      loading={loading}
      error={error}
      title={title}
      acceptLabel={acceptLabel}
      content={<PrivacyPolicyContent />}
      lastUpdatedLabel={PRIVACY_LAST_UPDATED_LABEL}
    />
  );
}
